export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./jackpots-bar.vue?vue&type=template&id=264d9815"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpots-bar/jackpots-bar.vue?vue&type=template&id=264d9815
// module id = scJ0
// module chunks = 0